export default "__VITE_ASSET__BrCoDwdW__"